module.exports = __webpack_public_path__ + "static/media/Dashboard_Reward.a4623c6c.svg";